import useAuthStore from "@/store/authStore";
import React, { useEffect, useState } from "react";
import { useNavigate, Navigate, Outlet } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import Spinner from "../ui/Spinner";
import useGlobalStore from "@/store/globalStore";

const PrivateRoute: React.FC = () => {
  const navigate = useNavigate();
  const { user, getAuth } = useAuthStore(
    useShallow((state) => ({
      user: state.user,
      getAuth: state.getAuth,
    }))
  );
  const setError = useGlobalStore((state) => state.setError);

  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      await getAuth();
    } catch (error) {
      setError(error.message);
      navigate("/login");
    }

    setLoading(false);
  };

  useEffect(() => {
    checkAuth();
  }, [getAuth]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size={40} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
